function isNonProd(hostname = window.location.hostname) {
  return /^(dev|qat|cat|prv)(-|\.)/gi.test(hostname) || /(^|\.)localhost($|\.)/gi.test(hostname)
}

function isQAT(hostname = window.location.hostname) {
  return hostname.startsWith('qat.')
}

function isCAT(hostname = window.location.hostname) {
  return hostname.startsWith('cat.')
}

function isPRV(hostname = window.location.hostname) {
  return hostname.startsWith('prv.')
}

function isLOCAL(hostname = window.location.hostname) {
  return hostname.includes('localhost')
}

function isProd(hostname = window.location.hostname) {
  return !isNonProd(hostname)
}

function isAgentCrawler(userAgent = window.navigator.userAgent) {
  return userAgent.includes('GDPP CRAWLER')
}

export { isNonProd, isProd, isAgentCrawler, isCAT, isQAT, isPRV, isLOCAL }
